import { fetchApi, fetchApiWithProgress } from './api';
import { API_ENDPOINTS, getPublicApiUrl, getApiUrl } from '../config';

export const getShopOffers = async (shopId) => {
    return fetchApi(API_ENDPOINTS.shopOffers(shopId), { method: 'GET' }, getPublicApiUrl);
};

export const createShopOffer = async (shopId, offerDescription, imageFile, startDate, endDate, onUploadProgress) => {
  const formData = new FormData();
  formData.append('offer_description', offerDescription);
  formData.append('image', imageFile);

  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = formatDate(endDate);

  if (formattedStartDate) {
    formData.append('start_date', formattedStartDate);
  }
  if (formattedEndDate) {
    formData.append('end_date', formattedEndDate);
  }

  return fetchApiWithProgress(API_ENDPOINTS.createShopOffer(shopId), {
    method: 'POST',
    body: formData,
    onUploadProgress,
  }, getApiUrl);
};

export const deleteShopOffer = async (offerId) => {
    return fetchApi(API_ENDPOINTS.deleteShopOffer(offerId), {
        method: 'DELETE',
    }, getApiUrl);
};
